/*
 * Copyright 2026, IntraLinks, Inc. All rights reserved.
 */

import { ILoaInstanceRepository, LoaInstanceResult } from '../ILoaInstanceRepository';
import { RequestsHandlerInstance } from '../utils/RequestsHandler';

export default class LoaInstanceRepository implements ILoaInstanceRepository {
  // eslint-disable-next-line no-empty-function
  constructor(private requestsHandler: RequestsHandlerInstance) {}

  async fetchInstance(action: string): Promise<LoaInstanceResult> {
    const response = await this.requestsHandler.patch('loaInstance', { data: { action } });
    const body = response.data?.data;
    return { instance: body.instance, level: body.level };
  }
}
